import 'factory/alert';
import 'factory/XSLT';

angular.module('TInv.showXML', [
    'ui.bootstrap',
    'TInv.XSLT',
    'TInv.util',
    'TInv.alert',
]).factory('showXML', function ($log, $window, $rootScope, $uibModal, revision, XSLT, x2js, FileUtil) {
    var styles = [{
        label: 'Official',
        xslt: 'fatturapa.xsl?rev=' + revision,
    }, {
        label: 'Alternative',
        xslt: 'AssoSoftware.xsl?rev=' + revision,
    }, {
        label: 'XML',
        xslt: 'null',
    }];
    return function (style, file, accept) {
        $uibModal.open({
            templateUrl: 'template/showXML.html?rev=' + revision,
            scope: $rootScope.$new(true), // create isolated scope
            controller: function ($scope, $uibModalInstance) {
                $scope.showXML = false;
                $scope.attachments = null;
                $scope.html = null;
                $scope.xml = null;
                $scope.xmlSave = file;
                $scope.xmlBase = null;
                $scope.xmlFix=null;
                //$scope.IdSdi = IdSdi;
                $scope.signInfo = null;
                $scope.styles = styles;
                $scope.valueStyle = styles[style - 1];
                $scope.close = function () {
                    $uibModalInstance.dismiss('button');
                };
                $scope.save = function () {
                    FileUtil.saveXML($scope.xml, 'invoice.xml');
                };
                if (accept)
                    $scope.accept = function (accepted) {
                        $uibModalInstance.dismiss('accept');
                        accept(accepted);
                    };
                $scope.saveAttach = function (attach) {
                    FileUtil.saveWSDL(attach, (attach.FormatoAttachment == 'PDF') ? 'application/pdf' : 'application/octet-stream'); 
                };
                $scope.print = function () {
                    $window.print();
                };
                $scope.changedStyle = function() {
                    $scope.showXML = ($scope.valueStyle.label == 'XML');

                    try {
                        XSLT.transform(
                            $scope.valueStyle.xslt,
                            file
                        ).then(function (arr) {
                            //$scope.html = arr[0]; ignored
                            $scope.xmlBase = arr[1];
                            var p = x2js.xml_str2json($scope.xmlBase);
                            $log.info('JSON/XML fattura:', p);

                            //do not show cedente that will be swapped after upload
                            delete p.FatturaElettronica.FatturaElettronicaHeader.CedentePrestatore;
                            try{
                                if(p.FatturaElettronica.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario === '1234567')
                                    p.FatturaElettronica.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario = '0000000';
                            }catch(e){/*ignore*/}
                            try{
                                if(p.FatturaElettronica.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.CodiceFiscale.startsWith('XXXXXX'))
                                    p.FatturaElettronica.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.CodiceFiscale = '';
                            }catch(e){/*ignore*/}
                            var attach = p.FatturaElettronica.FatturaElettronicaBody.Allegati;
                            if (attach && !('length' in attach))
                                attach = [attach];
                            $scope.attachments = attach;
                            if (p.FatturaElettronica.Signature)
                                $scope.signInfo = ''; //Dati firma : '+ p.FatturaElettronica.Signature.Object.QualifyingProperties.SignedProperties.SignedSignatureProperties.SigningCertificate.Cert.IssuerSerial.X509IssuerName.__text + ' | ' + p.FatturaElettronica.Signature.Object.QualifyingProperties.SignedProperties.SignedSignatureProperties.SigningTime.__text;
                            else
                                $scope.signInfo = '';

                            $scope.xmlBase = x2js.json2xml_str(p);
                        }).then(function(){
                            XSLT.transform(
                                $scope.valueStyle.xslt,
                                $scope.xmlBase
                            ).then(function (arr) {
                                $scope.html = arr[0];
                                $scope.xml = arr[1];
                            });
                        });
 
                    } catch (e) {
                        $log.info('Errore:', e);
                        throw new Error('Invalid XML structure.');
                    }
                };
                $scope.changedStyle();
            },
            windowClass: 'modal-invoice'
        });
    };
});
